<ngx-simplebar class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
  [options]="{ forceVisible: true }">
  <div class="card">
    <div class="documents-ai-entry" *ngIf="aiExtractionAvailable">
      <div>
        <strong>{{ 'ai-extraction.documents-tab.title' | translate }}</strong>
        <small class="d-block text-muted">{{ 'ai-extraction.documents-tab.hint' | translate }}</small>
      </div>
      <button type="button" class="btn btn-soft-primary btn-sm" (click)="requestAiExtraction()">
        <i class="ri-sparkling-2-fill me-1"></i>{{ 'ai-extraction.documents-tab.action' | translate }}
      </button>
    </div>
    <!--
      VERIFICAR — documentos obrigatórios por tipo de imóvel (modo tipado).

      É aqui que se confere o que falta: cada linha mostra o ficheiro anexado
      (com pré-visualização e remoção) sem obrigar a descer até às secções.
    -->
    <div class="documents-checklist-wrap" *ngIf="checklistRows.length > 0">
      <div class="documents-checklist-header">
        <div>
          <p class="documents-checklist-title mb-0">
            {{ 't-property-docs-checklist-title' | translate }}
            <i class="ri-question-line ms-1 text-muted" [ngbTooltip]="'t-property-docs-checklist-hint' | translate"
              placement="top" container="body"></i>
          </p>
          <small class="text-muted" *ngIf="requiredMissingNames.length > 0; else checklistComplete">
            {{ 't-property-docs-missing-count' | translate:{ count: requiredMissingNames.length } }}
          </small>
          <ng-template #checklistComplete>
            <small class="text-success">{{ 't-property-docs-complete' | translate }}</small>
          </ng-template>
        </div>
      </div>

      <ul class="documents-checklist list-unstyled mb-0">
        <li class="documents-checklist-row" *ngFor="let row of checklistRows; trackBy: trackByChecklistRow"
          [class.is-done]="row.done">
          <span class="documents-checklist-icon" aria-hidden="true">
            <i [ngClass]="row.done ? 'ri-checkbox-circle-fill text-success' : 'ri-checkbox-blank-circle-line text-muted'"></i>
          </span>

          <div class="documents-checklist-body">
            <div class="documents-checklist-name">
              <span>{{ row.name }}</span>
              <span class="badge ms-2" [ngClass]="row.isRequired ? 'badge-soft-danger' : 'badge-soft-secondary'">
                {{ (row.isRequired ? 't-property-docs-required' : 't-property-docs-optional') | translate }}
              </span>
            </div>

            <!-- Os ficheiros que cumprem esta linha, com as ações à mão. -->
            <div class="documents-checklist-files" *ngIf="row.done; else pendingLabel">
              <div class="documents-checklist-file" *ngFor="let doc of row.localDocs; trackBy: trackByDocument">
                <i class="documents-file-icon" [ngClass]="documentIconName(doc) + ' ' + documentIconColor(doc)"></i>
                <a href="javascript:void(0)" class="documents-checklist-file-name text-truncate"
                  [class.is-static]="doc.isNew" (click)="previewDocument(doc)">{{ doc.name }}</a>
                <span class="documents-checklist-file-meta text-muted">
                  {{ formatSizeUnits(doc.size) }} · {{ createDateFormat(doc.createdAt) }} ·
                  {{ visibilityLabelKey(doc.documentVisibility) | translate }}
                </span>
                <span class="documents-checklist-file-actions">
                  <button type="button" class="btn btn-sm btn-ghost-secondary btn-icon" *ngIf="canConsultDocument(doc)"
                    [ngbTooltip]="'t-preview' | translate" container="body" (click)="previewDocument(doc)">
                    <i class="ri-eye-line"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-ghost-danger btn-icon" *ngIf="canDeleteDocument(doc)"
                    [ngbTooltip]="'t-delete' | translate" container="body" (click)="deleteDoc(doc)">
                    <i class="ri-delete-bin-line"></i>
                  </button>
                </span>
              </div>
            </div>
            <ng-template #pendingLabel>
              <small class="text-muted">{{ 't-property-docs-pending' | translate }}</small>
            </ng-template>
          </div>

          <button type="button" class="btn btn-sm documents-checklist-attach" *ngIf="canAddDocuments"
            [ngClass]="row.done ? 'btn-ghost-secondary' : 'btn-soft-primary'" (click)="attachForType(row)">
            <i class="ri-attachment-2 me-1"></i>{{ 't-property-docs-attach' | translate }}
          </button>
        </li>
      </ul>
    </div>

    <div *ngIf="!typedMode && checklistRows.length > 0 && property?.id" class="documents-legacy-hint">
      <i class="ri-information-line me-1"></i>{{ 't-property-docs-legacy-hint' | translate }}
    </div>

    <div *ngIf="showDocumentsMinWarning" class="documents-warning-wrap">
      <div class="documents-warning-banner" role="alert">
        <span class="documents-warning-icon" aria-hidden="true">
          <i class="ri-error-warning-fill"></i>
        </span>

        <div class="documents-warning-content">
          <p class="documents-warning-title mb-0">
            {{ 't-m-properties.t-documents' | translate }}
          </p>

          <small class="documents-warning-subtitle">
            {{ 't-documents-min'
            | translate:{ min: documentsMinError?.valueMin, current: documentsMinError?.activeCount } }}
          </small>
        </div>
      </div>
    </div>

    <!--
      LISTAR — uma secção por visibilidade (comercial / interna / privada).

      Linhas compactas em vez da tabela de oito colunas: nome e detalhes à
      esquerda, o tipo de documento e o "no site" como chips (clicam-se só
      quando é preciso mudar), as ações no menu. A faixa de adicionar é fina e
      a secção inteira aceita ficheiros largados.
    -->
    <div class="card-body">
      <!-- Input global: usado pelo "Anexar" da checklist, que já traz o tipo. -->
      <input hidden type="file" (change)="onFileChange($event)" id="input-file-doc" multiple *ngIf="canAddDocuments"
        accept="application/pdf,image/png,image/jpg,image/jpeg,.kmz,application/vnd.google-earth.kmz,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" />

      <ng-container *ngFor="let section of documentSections; trackBy: trackByDocumentSection">
        <div class="documents-section" *ngIf="shouldShowDocumentSection(section)"
          [class.is-dragging]="draggingVisibility === section.visibility"
          (dragover)="onSectionDragOver($event, section.visibility)"
          (dragleave)="onSectionDragLeave($event)"
          (drop)="onSectionDrop($event, section.visibility)">

          <div class="documents-section-header">
            <p class="documents-section-title mb-0">
              <i class="ri-folder-3-line me-1 text-primary"></i>
              {{ section.label | translate }}
              <span class="badge bg-light text-muted ms-1">
                {{ (documentsByVisibility[section.visibility] || []).length }}
              </span>
              <i class="ri-question-line ms-1 text-muted" [ngbTooltip]="section.tooltip | translate" placement="top"
                container="body"></i>
            </p>

            <label class="documents-dropzone-inline" *ngIf="canAddDocuments"
              [ngbTooltip]="'t-deals-detail-dropzone-hint' | translate" placement="left" container="body">
              <input type="file" multiple hidden
                accept="application/pdf,image/png,image/jpg,image/jpeg,.kmz,application/vnd.google-earth.kmz,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                (change)="onSectionPick($event, section.visibility)" />
              <i class="ri-upload-cloud-2-line"></i>
              <span>{{ 't-add-document' | translate }}</span>
            </label>
          </div>

          <ng-container *ngIf="documentsByVisibility[section.visibility] as sectionDocs">
            <div class="documents-rows" *ngIf="sectionDocs.length > 0">
              <div class="documents-row" *ngFor="let data of sectionDocs; trackBy: trackByDocument">
                <div class="documents-row-icon" [ngClass]="documentIconColor(data)">
                  <i [ngClass]="documentIconName(data)"></i>
                </div>

                <div class="documents-row-main">
                  <a href="javascript:void(0)" class="documents-row-name text-truncate" [class.is-static]="data.isNew"
                    (click)="previewDocument(data)">{{ data.name }}</a>
                  <p class="documents-row-meta mb-0">
                    <span *ngIf="descriptionOf(data)">{{ descriptionOf(data) }} · </span>
                    {{ resolveFileType(data) }} · {{ formatSizeUnits(data.size) }} · {{ createDateFormat(data.createdAt) }}
                  </p>
                </div>

                <div class="documents-row-chips">
                  <!-- Tipo de documento: um chip que abre a lista; só quando se pode editar. -->
                  <!-- Sem container="body": dentro do modal do imóvel o body fica por baixo. -->
                  <div class="d-inline-block" ngbDropdown *ngIf="hasDocumentTypes">
                    <button type="button" class="documents-chip" ngbDropdownToggle
                      [class.is-set]="!!data.propertyDocumentTypeId" [class.is-editable]="canEditDocument(data)"
                      [disabled]="!canEditDocument(data)">
                      <i class="ri-price-tag-3-line"></i>
                      {{ documentTypeName(data.propertyDocumentTypeId) || ('t-property-docs-untyped' | translate) }}
                      <i class="ri-arrow-down-s-line documents-chip-caret" *ngIf="canEditDocument(data)"></i>
                    </button>
                    <div ngbDropdownMenu class="documents-chip-menu">
                      <button type="button" ngbDropdownItem *ngFor="let type of documentTypes"
                        [class.active]="type.id === data.propertyDocumentTypeId" (click)="setDocumentType(data, type.id)">
                        {{ type.name }}
                      </button>
                      <div class="dropdown-divider" *ngIf="data.propertyDocumentTypeId"></div>
                      <button type="button" ngbDropdownItem *ngIf="data.propertyDocumentTypeId"
                        (click)="setDocumentType(data, null)">
                        {{ 't-property-docs-untyped' | translate }}
                      </button>
                    </div>
                  </div>

                  <!-- Comerciais: "no site" é um chip que se liga e desliga. -->
                  <button type="button" class="documents-chip" *ngIf="section.visibility === 'COMMERCIAL'"
                    [class.is-set]="data.showOnWebsite" [class.is-editable]="canEditDocument(data)"
                    [disabled]="!canEditDocument(data)" (click)="toggleShowOnWebsite(data)"
                    [ngbTooltip]="'t-m-properties.t-show-on-website-tooltip' | translate" container="body">
                    <i [ngClass]="data.showOnWebsite ? 'ri-global-line' : 'ri-eye-off-line'"></i>
                    {{ 't-m-properties.t-show-on-website' | translate }}
                  </button>
                </div>

                <div class="documents-row-actions">
                  <button type="button" class="btn btn-sm btn-ghost-secondary btn-icon me-1" *ngIf="canConsultDocument(data)"
                    [ngbTooltip]="'t-preview' | translate" (click)="previewDocument(data)">
                    <i class="ri-eye-line"></i>
                  </button>
                  <div class="dropdown" ngbDropdown
                    [ngStyle]="{'cursor': (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) || data.isNew || !property?null:'not-allowed'}">
                    <a href="javascript:void(0);" class="btn btn-soft-primary btn-sm btn-icon arrow-none"
                      ngbDropdownToggle
                      [ngStyle]="{'pointer-events': canUseDocumentActions(data)?null:'none'}">
                      <i class="ri-more-fill"></i>
                    </a>

                    <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu
                      *ngIf="canUseDocumentActions(data)">
                      <li *ngIf="canEditDocument(data)">
                        <a class="dropdown-item " href="javascript:void(0);" (click)="editDocument(data)"><i
                            class="ri-pencil-fill me-2 align-bottom text-muted"></i>
                          {{'t-m-properties.t-edit-description'|translate}}
                        </a>
                      </li>

                      <ng-container *ngIf="canEditDocument(data)">
                        <li class="dropdown-divider"></li>
                        <li *ngFor="let moveSection of moveDocumentSectionsByVisibility[section.visibility]">
                          <a class="dropdown-item" href="javascript:void(0);"
                            (click)="moveDocumentToVisibility(data, moveSection.visibility)">
                            <i class="ri-arrow-left-right-line me-2 align-bottom text-muted"></i>
                            {{'t-move-to'|translate}} {{ moveSection.label | translate }}
                          </a>
                        </li>
                      </ng-container>

                      <li *ngIf="canConsultDocument(data)">
                        <a class="dropdown-item" href="javascript:void(0);" (click)="previewDocument(data)">
                          <i class="ri-eye-line me-2 align-bottom text-muted"></i>
                          {{ 't-preview' | translate }}
                        </a>
                      </li>
                      <li *ngIf="canConsultDocument(data)">
                        <a class="dropdown-item" href="javascript:void(0);" (click)="openDocumentQuickly(data)">
                          <i class="ri-external-link-line me-2 align-bottom text-muted"></i>
                          {{'t-open-in-new-tab' | translate}}
                        </a>
                      </li>
                      <li *ngIf="canDownloadDocument(data)">
                        <a class="dropdown-item" [href]="getDocumentUrl(data.fileName)">
                          <i class="ri-download-2-fill me-2 align-bottom text-muted"></i>
                          {{ 't-download' | translate }}
                        </a>
                      </li>

                      <li *ngIf="canDeleteDocument(data)" class="dropdown-divider"></li>

                      <li *ngIf="canDeleteDocument(data)">
                        <a class="dropdown-item" (click)="deleteDoc(data)" href="javascript:void(0);"><i
                            class="ri-delete-bin-5-fill me-2 align-bottom text-muted"></i>{{'t-delete'|translate}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</ngx-simplebar>
